<template>
  <div class="footer">
    <div class=" flex just-between common-width-box">
      <div class="flex">
        <div class="logo">
          <img class="w-h-100" style="object-fit:contain;" :src="systemConfig.logoFile.url" alt="LOGO">
        </div>
      </div>
      <div class="flex flex-column just-center">
        <p v-for="(item, index) in infoItemList" :key="index" style="padding: 10px 0;">
          <span>{{item.name}}：</span>{{item.info}}
        </p>
      </div>
      <div class="flex flex-column just-center" style="width:300px;">
        <div style="width: 110px;height: 110px;">
          <img class="w-h-100" style="object-fit:contain;" :src="systemConfig.qrCodeFile.url" alt="">
        </div>
        <div style="text-align:center;color:#fff;width:110px;margin-top: 10px;font-size: 14px;">{{systemConfig.publicAccounts}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infoItemList: [],
      systemConfig: {
        logoFile: {
          url: ""
        },
        qrCodeFile: { url: "" },
        publicAccounts: ""
      }
    }
  },
  methods: {
    getInfoItemList() {
      this.$api.index.getInfoItemList().then(res => {
        if (res.code === 200) {
          this.infoItemList = res.data
        }
        console.info(this.infoItemList)
      })
    },
    getSystemConfig() {
      this.$api.index.getSystemConfig().then(res => {
        if (res.code === 200) {
          Object.assign(this.systemConfig, res.data);
        }
      })
    }
  },
  mounted() {
      this.getInfoItemList();
      this.getSystemConfig();
    }
}
</script>

<style lang='less' scoped>
</style>
